/* eslint-disable consistent-return */
import React from 'react';
import { CompetitionRegistrationContext } from 'contexts';
import { hexToRgb } from '@material-ui/core';
import { secondary } from 'core/ui/Colors';
import RegistrationTypeSelector from './RegistrationTypeSelector';
import useCompRegistration, { registrationSteps } from './useCompRegistration';
import RegistrationFinish from './RegistrationFinish';

export default ({ close }) => {
  const registration = useCompRegistration({ close });

  const optionBgColor = () => {
    const c = registration?.competition?.backgroundColor || secondary;
    const rgb = hexToRgb(c).replace('rgb(', '').replace(')', '');
    const splitRgb = rgb.split(',');

    const darker = (x) => {
      return x - x * 0.1;
    };
    const light = (x) => {
      return x * 1.8;
    };

    if (registration?.competition?.darkBackground) {
      return `rgb(${light(splitRgb[0])}, ${light(splitRgb[1])}, ${light(splitRgb[2])})`;
    }

    return `rgb(${darker(splitRgb[0])}, ${darker(splitRgb[1])}, ${darker(splitRgb[2])})`;
  };

  return (
    <>
      <CompetitionRegistrationContext.Provider
        value={{ ...registration, close, cardBgColor: optionBgColor() }}
      >
        {registration.step === registrationSteps.chooseType && <RegistrationTypeSelector />}
        {registration.step === registrationSteps.finish && <RegistrationFinish />}
      </CompetitionRegistrationContext.Provider>
    </>
  );
};
